import axios from 'axios'

const API_URL = process.env.VUE_APP_AI_AGENT_API_BASE_URL || 'https://localhost:5001/api/'

class IntegrationService {
  // Get all integrations for a project
  getIntegrationsByProject (projectId) {
    return axios.get(API_URL + 'projects/' + projectId + '/integrations')
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching integrations:', error)
        throw error
      })
  }

  // Get specific integration
  getIntegrationById (projectId, integrationId) {
    return axios.get(API_URL + 'projects/' + projectId + '/integrations/' + integrationId)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching integration:', error)
        throw error
      })
  }

  // Create new integration
  createIntegration (projectId, integrationData) {
    return axios.post(API_URL + 'projects/' + projectId + '/integrations', integrationData)
      .then(response => response.data)
      .catch(error => {
        console.error('Error creating integration:', error)
        throw error
      })
  }

  // Update integration
  updateIntegration (projectId, integrationId, integrationData) {
    return axios.put(API_URL + 'projects/' + projectId + '/integrations/' + integrationId, integrationData)
      .then(response => response.data)
      .catch(error => {
        console.error('Error updating integration:', error)
        throw error
      })
  }

  // Delete integration
  deleteIntegration (projectId, integrationId) {
    return axios.delete(API_URL + 'projects/' + projectId + '/integrations/' + integrationId)
      .then(response => response.data)
      .catch(error => {
        console.error('Error deleting integration:', error)
        throw error
      })
  }

  // Test integration connection
  testIntegration (projectId, integrationId) {
    return axios.post(API_URL + 'projects/' + projectId + '/integrations/' + integrationId + '/test')
      .then(response => response.data)
      .catch(error => {
        console.error('Error testing integration:', error)
        throw error
      })
  }

  // Execute integration manually
  executeIntegration (projectId, integrationId, parameters) {
    return axios.post(API_URL + 'projects/' + projectId + '/integrations/' + integrationId + '/execute', parameters)
      .then(response => response.data)
      .catch(error => {
        console.error('Error executing integration:', error)
        throw error
      })
  }

  // Get integration execution logs
  getIntegrationLogs (projectId, integrationId, limit) {
    var url = API_URL + 'projects/' + projectId + '/integrations/' + integrationId + '/logs'
    if (limit) {
      url = url + '?limit=' + limit
    }
    return axios.get(url)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching integration logs:', error)
        throw error
      })
  }
}

export default new IntegrationService()
